import React, { useEffect, useState } from "react";
import {
  AppBar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { styled } from "@mui/system";
import { Link, useNavigate } from "react-router-dom";
import { eraseCookie } from "../../utils/cookies";
import useCheckProfile from "../../api/effects/queries/User/useFetchCheckProfile";
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import ProfileState from "../../recoil/ProfileState";
import UserState from "../../recoil/UserState";
import { fotoProfileUrlState, photoFetchStatusState } from "../../recoil/UserFotoProfileState";
import useFetchFotoProfile from "../../api/effects/queries/DataPribadi/useFetchFotoProfile";
import { clearProfilePhotoFromStorage } from "../../utils/photoStorage";
import { useQueryClient } from "react-query";

const ClearLink = styled(Link)({
  textDecoration: "none",
  fontSize: "1.4em",
  textTransform: "none",
});

export default function HeaderUser() {
  const navigate = useNavigate();
  useFetchFotoProfile();

  const { data: ProfileData } = useCheckProfile();
  const setRecoil = useSetRecoilState(ProfileState);
  const recoilValue = useRecoilValue(ProfileState);
  const recoilValueFotoProfile = useRecoilValue(fotoProfileUrlState);


  useEffect(() => {
    if (ProfileData !== undefined) {
      const DataProfile = ProfileData.USER_DATA_COUNT > 0;
      const PendidikanProfile = ProfileData.USER_PENDIDIKAN_COUNT > 2;
      const KeluargaProfile = ProfileData.USER_KELUARGA_COUNT > 3;
      const QuestionnaireProfile =
        ProfileData.LAST_UPDATED < 30 &&
        ProfileData.PERTANYAAN_ACTIVE_COUNT === ProfileData.JAWABAN_USER_COUNT;
      const KontakDaruratProfile = ProfileData.USER_KONTAK_DARURAT_COUNT > 0;
      const KontakReferensiProfile = ProfileData.USER_KONTAK_REFERENSI_COUNT > 0;

      setRecoil({
        Data: DataProfile,
        Pendidikan: PendidikanProfile,
        Keluarga: KeluargaProfile,
        Pekerjaan: true,
        Questionnaire: QuestionnaireProfile,
        KontakDarurat: KontakDaruratProfile,
        KontakReferensi: KontakReferensiProfile,
      });
    }
  }, [ProfileData, setRecoil]);



  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const queryClient = useQueryClient();

  const removeRecoilUser = useResetRecoilState(UserState);
  const removeRecoilProfile = useResetRecoilState(ProfileState);
  const removeRecoilFoto = useResetRecoilState(fotoProfileUrlState);
  const removePhotoFetchStatus = useResetRecoilState(photoFetchStatusState);

  const eraseAuthCookie = async () => {
    removeRecoilFoto();
    removeRecoilProfile();
    removeRecoilUser();
    removePhotoFetchStatus();
    clearProfilePhotoFromStorage();
    queryClient.clear();
    eraseCookie("token");
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfile = () => {
    navigate("/Profile");
  };

  const handlePassword = () => {
    navigate("/ChangePassword");
  };

  const handleLogout = () => {
    eraseAuthCookie().then(() => {
      window.location.reload();
    });
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        sx={{
          backgroundColor: "rgba(255, 255, 255, 0.3)",
          backgroundImage: `linear-gradient(to bottom right, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0))`,
          backdropFilter: `blur(20px)`,
          boxShadow: "10px 10px 10px rgba(30, 30, 30, 0.1)",
          backgroundSize: "100vw 100%",
          paddingLeft: "3%",
          paddingRight: "3%",
        }}
      >
        <Toolbar>
          <ClearLink to="/">
            <Box
              component="img"
              src={`${process.env.PUBLIC_URL}/images/LogoIndomobilCareer.png`}
              alt="IndomobilCareerLogo"
              sx={{
                width: "auto",
                height: "8vh",
                paddingTop: "2px",
                paddingBottom: "2px",
              }}
            />
          </ClearLink>
          <Typography sx={{ flexGrow: 1 }} />
          <IconButton
            size="large"
            edge="start"
            aria-label="menu"
            sx={{
              border:
                (recoilValue?.Data === false ||
                  recoilValue?.Pendidikan === false ||
                  recoilValue?.Pekerjaan === false ||
                  recoilValue?.Keluarga === false ||
                  recoilValue?.Questionnaire === false ||
                  recoilValue?.KontakDarurat === false ||
                  recoilValue?.KontakReferensi === false)
                  ? "solid 1px #ff604f"
                  : "solid 1px rgb(0, 172, 237)",
              mr: 2,
              color: "black",
              width: "7vh",
              height: "7vh",
              padding: "5px",
            }}
            onClick={handleClick}
          >
            {recoilValueFotoProfile ? (
              <Box
                component="img"
                src={recoilValueFotoProfile}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                  borderRadius: "90px",
                }}
              />
            ) : (
              <AccountCircleIcon
                color={
                  (recoilValue?.Data === false ||
                    recoilValue?.Pendidikan === false ||
                    recoilValue?.Pekerjaan === false ||
                    recoilValue?.Keluarga === false ||
                    recoilValue?.Questionnaire === false ||
                    recoilValue?.KontakDarurat === false ||
                    recoilValue?.KontakReferensi === false)
                    ? "error"
                    : "inherit"
                }
              />
            )}
          </IconButton>
          <Menu
            id="profile-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "profile-menu-button",
            }}
          >
            <MenuItem onClick={handleProfile}>
              <Typography
                color={
                  (recoilValue?.Data === false ||
                    recoilValue?.Pendidikan === false ||
                    recoilValue?.Pekerjaan === false ||
                    recoilValue?.Keluarga === false ||
                    recoilValue?.Questionnaire === false ||
                    recoilValue?.KontakDarurat === false ||
                    recoilValue?.KontakReferensi === false)
                    ? "error"
                    : "inherit"
                }
              >
                Profile
              </Typography>
            </MenuItem>
            <MenuItem onClick={handlePassword}>Change Password</MenuItem>
            <MenuItem onClick={handleLogout}>
              <Typography color="error">Logout</Typography>
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
    </Box>
  );
}